// extracted by mini-css-extract-plugin
export default {"trenton":"Riddles_trenton__W0oUi"};